class PaymentMigration {
    constructor() {
        this.canMigrate = null;
        this.token = null;
        this.old = null;
        this.new = null;
        this.obsoletePlanScenario = null;
    }
}

export { PaymentMigration };
